export const questions = [
  {
    id: 1,
    question: "What's your biggest parenting challenge right now?",
    options: [
      { text: "Managing morning routines and transitions", response: "struggles with daily routines and transitions, particularly in the mornings" },
      { text: "Handling emotional outbursts and tantrums", response: "dealing with emotional regulation challenges and outbursts" },
      { text: "Setting boundaries and maintaining consistency", response: "finding it difficult to set and maintain consistent boundaries" },
      { text: "Balancing work and family time", response: "working to find the right balance between professional responsibilities and quality family time" }
    ]
  },
  {
    id: 2,
    question: "How does your biggest parenting challenge impact your daily life?",
    options: [
      { text: "Creates constant stress and anxiety", response: "experiencing ongoing stress and anxiety around parenting challenges" },
      { text: "Affects relationships with partner/family", response: "noticing strain on relationships with partner and other family members" },
      { text: "Impacts work performance", response: "finding that parenting challenges are affecting work performance" },
      { text: "Reduces quality time with children", response: "feeling that challenges are reducing meaningful connection time with children" }
    ]
  },
  {
    id: 3,
    question: "Which areas of your life are most affected?",
    options: [
      { text: "Mental and emotional well-being", response: "particularly impacted in terms of mental and emotional well-being" },
      { text: "Professional growth", response: "seeing effects on professional development and career growth" },
      { text: "Personal relationships", response: "experiencing strain on personal relationships" },
      { text: "Physical health and energy", response: "noticing impacts on physical health and energy levels" }
    ]
  },
  {
    id: 4,
    question: "What's your biggest obstacle to making positive changes?",
    options: [
      { text: "Lack of time and energy", response: "finding it challenging to find the time and energy needed for change" },
      { text: "Inconsistent partner support", response: "dealing with inconsistent support from partner in parenting approaches" },
      { text: "Overwhelm with information", response: "feeling overwhelmed by conflicting parenting advice and information" },
      { text: "Fear of making mistakes", response: "concerned about making mistakes or choosing the wrong approach" }
    ]
  },
  {
    id: 5,
    question: "How would you describe your current parenting style?",
    options: [
      { text: "Structured and consistent", response: "tends to maintain structure and consistency in parenting" },
      { text: "Flexible and adaptive", response: "takes a flexible, adaptive approach to parenting" },
      { text: "Emotional and intuitive", response: "relies on emotional connection and intuition in parenting" },
      { text: "Mixed and evolving", response: "currently developing and adjusting parenting style" }
    ]
  },
  {
    id: 6,
    question: "What's your primary goal for working with a coach?",
    options: [
      { text: "Develop better routines and systems", response: "seeking to establish more effective routines and systems" },
      { text: "Improve emotional connection", response: "wanting to strengthen emotional bonds and understanding" },
      { text: "Learn specific parenting techniques", response: "looking to learn and implement specific parenting strategies" },
      { text: "Build confidence as a parent", response: "aiming to build greater confidence in parenting abilities" }
    ]
  },
  {
    id: 7,
    question: "What coaching style do you think works best for you?",
    options: [
      { text: "Direct and structured guidance", response: "prefers clear, structured guidance and direction" },
      { text: "Collaborative problem-solving", response: "values collaborative approach to finding solutions" },
      { text: "Supportive and encouraging", response: "responds well to supportive, encouraging coaching" },
      { text: "Data-driven and research-based", response: "appreciates evidence-based, research-supported approaches" }
    ]
  }
]; 